"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LEGAL_ACCEPTANCE_SIGNUP_DESCRIPTION_COPY = exports.PRIVACY_POLICY_LINK_COPY = exports.TERMS_OF_SERVICE_LINK_COPY = exports.TERMS_AGREEMENT_LEAD_COPY = void 0;
/**
 * AN-26 (Anthony's batch, 9 Oct; web and mobile, rule 17, wording agreed 2026-10-12):
 * the sign-up consent sentence, the ONE wording for both apps. Split so each app can
 * make the two document names its own links. Rendered:
 *
 *   TERMS_AGREEMENT_LEAD_COPY + " " + TERMS_OF_SERVICE_LINK_COPY + " and " +
 *   PRIVACY_POLICY_LINK_COPY + "."
 *
 * "I agree to the Terms of Service and Privacy Policy." (with the full stop).
 */
exports.TERMS_AGREEMENT_LEAD_COPY = "I agree to the";
exports.TERMS_OF_SERVICE_LINK_COPY = "Terms of Service";
exports.PRIVACY_POLICY_LINK_COPY = "Privacy Policy";
/**
 * AN-25 (Paul, 2026-10-22): the consent prompt a new Google/Apple account sees right after
 * sign-up. Web's SSO-complete page already says it this way (SSOComplete.tsx); the phone's
 * sign-up prompt (PendingConsentHost) uses this key. The bank-connect gate keeps its own
 * sentence ("Before you connect a bank, …").
 */
exports.LEGAL_ACCEPTANCE_SIGNUP_DESCRIPTION_COPY = "Before you start, review and accept the current Terms of Service and Privacy Policy.";
//# sourceMappingURL=legalConsentCopy.js.map